export const AUTHENTICATION_STATUS = Object.freeze({
  AUTHENTICATED: 'authenticated',
  ERROR: 'error',
  LOADING: 'loading',
  UNAUTHENTICATED: 'unauthenticated',
  UNKNOWN: 'unknown',
});
